import { MultiSelectTagPicker } from '@shared/components';
import { TERMINOLOGY } from '@shared/i18n';
import { useProductFolders } from '@modules/items';
import type { TSparseItem } from '@modules/items';
import type { TRegistrationList, TRegistrationScopeFilters } from '../types';

type TProps = {
  filters: TRegistrationScopeFilters;
  choices?: TRegistrationList['filters'];
  onChange: (changes: Partial<TRegistrationScopeFilters>) => void;
};

const toOptions = (items: TSparseItem[] = []) => items.map(({ _id, name }) => ({ value: _id, label: name }));

const RegistrationsScopeSelectors = ({ filters, choices, onChange }: TProps) => {
  // Use the same product list as registration creation, including products without registrations.
  const products = useProductFolders();

  return (
    <div className="flex flex-wrap items-start gap-3">
      <MultiSelectTagPicker
        label={TERMINOLOGY.registrationCountry.upper}
        className="w-72 max-w-full"
        options={toOptions(choices?.countries)}
        selectedOptions={filters.countryIds}
        onChange={(countryIds) => onChange({ countryIds })}
        placeholder="All countries"
        inputAriaLabel="Select countries"
        selectedAriaLabel="Selected countries"
        noMatchesMessage="No matching country."
      />
      <MultiSelectTagPicker
        label={TERMINOLOGY.product.upper}
        className="w-72 max-w-full"
        options={toOptions(products)}
        selectedOptions={filters.productIds}
        onChange={(productIds) => onChange({ productIds })}
        placeholder="All products"
        inputAriaLabel="Select products"
        selectedAriaLabel="Selected products"
        noMatchesMessage="No matching product."
      />
    </div>
  );
};

export default RegistrationsScopeSelectors;
